import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Modal, Table, Card, Form } from "react-bootstrap";
import { Store } from "react-notifications-component";
import axios from "axios";
import { Divider } from "rsuite";
import PermissionContext from "../../../Store/permission-context";
const ReceiptSalesRecordsModal = (props) => {
  const [AxiosError, setAxiosError] = useState("");
  const [reload, setreload] = useState(false);
  const [HasEdited, setHasEdited] = useState(false);
  const [ShowModal, setShowModal] = useState(props.showmodal);
  const [ThisReceiptDetails, setThisReceiptDetails] = useState(
    props.paymentReceipt.RDetails
  );
  const [NewPayable, setNewPayable] = useState(
    props.paymentReceipt.RInfo.RPayable
  );
  const [RProfit, setRProfit] = useState(props.paymentReceipt.RInfo.RPft);
  const [RMode, setRMode] = useState(props.paymentReceipt.RInfo.RMode);
  const [RID, setRID] = useState(props.paymentReceipt.RInfo.RID);
  const [newTender, setnewTender] = useState(props.paymentReceipt.RInfo.Tender);
  const [newchangecollected, setnewchangecollected] = useState(
    props.paymentReceipt.RInfo.ChangeCollected
  );
  const [newcash, setnewcash] = useState(props.paymentReceipt.RInfo.cash);
  const [newpos, setnewpos] = useState(props.paymentReceipt.RInfo.pos);
  const [newtransfer, setnewtransfer] = useState(
    props.paymentReceipt.RInfo.transfer
  );
  const [DisableAll, setDisableAll] = useState(false);
  const [Printing, setPrinting] = useState(true);
  const [PaymentModePerfect, setPaymentModePerfect] = useState(false);
  const PCtx = useContext(PermissionContext);
  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);
  const [ItemsToDelete, setItemsToDelete] = useState([]);

  useEffect(() => {
    let Cs = newcash === "" ? 0 : parseFloat(newcash);
    let Ps = newpos === "" ? 0 : parseFloat(newpos);
    let Ts = newtransfer === "" ? 0 : parseFloat(newtransfer);
    let AllMode = Cs + Ps + Ts;
    if (AllMode != 0 && parseFloat(AllMode) === parseFloat(NewPayable)) {
      setPaymentModePerfect(true);
    } else {
      setPaymentModePerfect(false);
    }
  }, [newcash, newpos, newtransfer, NewPayable]);

  // useEffect(() => {
  //   if (parseFloat(newTender) >= parseFloat(NewPayable)) {
  //     setnewchangecollected(parseFloat(newTender) - parseFloat(NewPayable));
  //   } else {
  //     setnewchangecollected(0);
  //   }
  // }, [newTender]);

  useEffect(() => {
    if (HasEdited) {
      setnewTender("");
      setnewchangecollected("");
    }
  }, [NewPayable]);

  const setTheValue = (e) => {
    let nm = e.target.name;
    let vl = e.target.value;

    if (nm === "newcash" && !isNaN(vl)) {
      setnewcash(vl);
    } else {
      if (nm === "newpos" && !isNaN(vl)) {
        setnewpos(vl);
      } else {
        if (nm === "newtransfer" && !isNaN(vl)) {
          setnewtransfer(vl);
        } else {
          if (nm === "newTender" && !isNaN(vl)) {
            setnewTender(vl);
          } else {
            if (nm === "newchangecollected" && !isNaN(vl)) {
              setnewchangecollected(vl);
            }
          }
        }
      }
    }
  };

  const SaveNewReceipt = async () => {
    let DeleteDetails = {
      ItemsToDelete: ItemsToDelete,
      NewCash: newcash ? newcash : 0,
      NewPos: newpos ? newpos : 0,
      NewTransfer: newtransfer ? newtransfer : 0,
      NewTender: newTender ? newTender : 0,
      NewChangeCollected: newchangecollected ? newchangecollected : 0,
      RID: RID,
      NewPayable: NewPayable,
      RMode: RMode ? RMode : "",
      RProfit: RProfit,
    };

    const DeleteItem = await PCtx.connectAxios(
      "deletesalesitem.php",
      DeleteDetails
    );

    // console.log(DeleteItem);

    if (!DeleteItem.includes("Failure")) {
      PCtx.displayAlert(
        "SUCCESS",
        "Item(s) deleted successfully and the quantity has been returned  to the stock (inventory)",
        "success"
      );
      props.NextEvent(true);
    } else {
      PCtx.displayAlert(
        "ERROR",
        "Items cannot be deleted. Please contact the administrator",
        "danger"
      );
    }
  };

  const DeleteThisItem = async (
    rctid,
    itid,
    total,
    pft,
    ordername,
    ddb,
    nop,
    nou,
    rinfo
  ) => {
    let np = parseFloat(NewPayable) - parseFloat(total);
    setNewPayable(np);
    setHasEdited(true);

    let pt = parseFloat(RProfit) - parseFloat(pft);
    setRProfit(pt);

    let delitem = {
      rctid: rctid,
      itid: itid,
      total: total,
      pft: pft,
      ordername: ordername,
      ddb: ddb,
      nop: nop,
      nou: nou,
      rpble: rinfo.RPayable,
      rpmode: rinfo.RMode,
      rcust: rinfo.RCust,
      rpft: rinfo.RPft,
      Username: PCtx.Username,
    };

    setItemsToDelete([...ItemsToDelete, delitem]);
    let newreceipt = ThisReceiptDetails.filter((r) => r.salesid !== itid);
    setThisReceiptDetails(newreceipt);
  };

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={props.NextEvent}
        backdrop="static"
        keyboard={false}
        style={{ fontFamily: "Times New Roman", color: "brown" }}
      >
        <Modal.Header style={successBackStyle} closeButton>
          <Modal.Title style={{ color: "white", fontSize: "15px" }}>
            ITEMS BOUGHT ON THIS RECEIPT
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Row>
            <Col md={12} lg={12} sm={12} xs={12}>
              <Row>
                <Col md={12} sm={12}>
                  <Card>
                    <Card.Body>
                      <Row>
                        <Col
                          md={12}
                          sm={12}
                          style={{
                            height: "350px",
                            overflowY: "scroll",
                            marginButtom: "20px",
                          }}
                        >
                          <Table
                            striped
                            bordered
                            hover
                            style={{ fontFamily: "Times New Roman" }}
                          >
                            <thead>
                              <tr>
                                <th>SN</th>
                                <th>ITEMS BOUGHT</th>
                                <th>BULK</th>
                                <th>UNIT</th>
                                <th>AMOUNT PAID</th>
                                <th>PROFIT</th>
                                {props.Group === "Group" && <th>DELETE</th>}
                              </tr>
                            </thead>
                            <tbody>
                              {ThisReceiptDetails.map((rct, index) => (
                                <tr key={index}>
                                  <td className="text-center">{index + 1}</td>
                                  <td className="text-center">
                                    {rct.ordername}
                                  </td>
                                  <td className="text-center">{rct.nop}</td>
                                  <td className="text-center">{rct.nou}</td>
                                  <td className="text-center">
                                    {rct.subtotal}
                                  </td>
                                  <td className="text-center">{rct.profit}</td>
                                  {props.Group === "Group" && (
                                    <td className="text-center">
                                      <Button
                                        variant="danger"
                                        className="btn btn-sm"
                                        onClick={() =>
                                          DeleteThisItem(
                                            rct.RID,
                                            rct.salesid,
                                            rct.subtotal,
                                            rct.profit,
                                            rct.ordername,
                                            rct.ddb,
                                            rct.nop,
                                            rct.nou,
                                            props.paymentReceipt.RInfo
                                          )
                                        }
                                      >
                                        -
                                      </Button>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={12} sm={12}>
                  <Card>
                    <Card.Body className="py-1">
                      <Row
                        className="justify-content-center"
                        style={{ backgroundColor: "" }}
                      >
                        <Col md={4} lg={4} xs={4} sm={4}>
                          <Form.Group className="mb-0" controlId="name">
                            <Form.Label
                              style={{ color: "brown" }}
                              className="my-0"
                            >
                              Cash
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={newcash}
                              name="newcash"
                              onChange={setTheValue}
                              className="my-0"
                              readOnly={DisableAll}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4} lg={4} xs={4} sm={4}>
                          <Form.Group className="mb-0" controlId="name">
                            <Form.Label
                              style={{ color: "brown" }}
                              className="my-0"
                            >
                              POS
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={newpos}
                              name="newpos"
                              className="my-0"
                              onChange={setTheValue}
                              readOnly={DisableAll}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4} lg={4} xs={12} sm={12}>
                          <Form.Group className="mb-0" controlId="name">
                            <Form.Label
                              style={{ color: "brown" }}
                              className="my-0"
                            >
                              Transfer
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={newtransfer}
                              name="newtransfer"
                              onChange={setTheValue}
                              className="my-0"
                              readOnly={DisableAll}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <hr className="p-1 m-1" />
                      {/* <Row
                        className="justify-content-center py-1 border border-dark-subtle"
                        style={{ backgroundColor: "#d2d2d2" }}
                      >
                        <Col md={4} lg={4} xs={12} sm={12}>
                          <Form.Group className="mb-0" controlId="name">
                            <Form.Label
                              style={{ color: "brown" }}
                              className="my-0"
                            >
                              Tender
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={newTender}
                              name="newTender"
                              onChange={setTheValue}
                              className="my-0"
                              readOnly={DisableAll}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4} lg={4} xs={12} sm={12}>
                          <Form.Group className="mb-0" controlId="name">
                            <Form.Label
                              style={{ color: "brown" }}
                              className="my-0"
                            >
                              Change
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={newchangecollected}
                              name="newchangecollected"
                              onChange={setTheValue}
                              className="my-0"
                              readOnly={DisableAll}
                            />
                          </Form.Group>
                        </Col>
                         <Col md={6}>
                            <label>Payment Mode</label>
                            <select
                              value={PaymentMode}
                              onChange={PaymentModeHandler}
                            >
                              <option value="">Select</option>
                              <option value="Cash">Cash</option>
                              <option value="POS">POS</option>
                              <option value="Transfer">Transfer</option>
                              <option value="Credit">Credit</option>
                            </select>
                          </Col> 
                      </Row> */}
                    </Card.Body>
                  </Card>
                  <Card style={{ height: "35px" }}>
                    <Card.Body>
                      <Divider className="m-0">
                        <h4 className="text-success ">
                          Total Payable = ₦{NewPayable}
                        </h4>
                      </Divider>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={12}>
                  <Button
                    variant="success"
                    className="w-100 mt-1"
                    disabled={
                      ThisReceiptDetails.length > 0 && PaymentModePerfect
                        ? false
                        : true
                    }
                    onClick={() => SaveNewReceipt()}
                  >
                    Save New Receipt
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  );
};

export default ReceiptSalesRecordsModal;
